module.exports = __webpack_public_path__ + "img/Slide28.d8635124.png";